<template lang="html">
  <b-icon :icon="genderIcon" value="Gender"></b-icon>
</template>

<script>
export default {
  props: [ 'gender' ],
  computed: {
    genderIcon () {
      switch (this.gender) {
        case 'male':
          return 'gender-male'
        case 'female':
          return 'gender-female'
        case 'nonbinary':
          return 'gender-non-binary'
        default:
          return 'jellyfish'
      }
    }
  }
}
</script>
